"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartLegend(_ref) {
  var data = _ref.data,
      labelNew = _ref.labelNew,
      labelCurrent = _ref.labelCurrent;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    points: data.currTriangle,
    className: "chart-triangle chart-color-1"
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: data.currX,
    y: data.currY,
    fontSize: "14px",
    className: "chart-legend"
  }, labelCurrent)), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    points: data.newTriangle,
    className: "chart-triangle chart-color-0"
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: data.newX,
    y: data.newY,
    fontSize: "14px",
    className: "chart-legend"
  }, labelNew)));
}

ChartLegend.propTypes = {
  data: _propTypes.default.shape({
    newX: _propTypes.default.number,
    newY: _propTypes.default.number,
    currX: _propTypes.default.number,
    currY: _propTypes.default.number,
    newTriangle: _propTypes.default.string,
    currTriangle: _propTypes.default.string
  }),
  labelNew: _propTypes.default.string,
  labelCurrent: _propTypes.default.string
};
ChartLegend.defaultProps = {
  data: {},
  labelNew: '',
  labelCurrent: ''
};
var _default = ChartLegend;
exports.default = _default;